// extracted by mini-css-extract-plugin
module.exports = {"input":"FormTextArea_input__LUIaF","wrapper":"FormTextArea_wrapper__JyzEx","outlined":"FormTextArea_outlined__93_TR"};